import angular from "angular";
import ckeditorConfig from "./CKEditorOptions";

/**
 * Standard textarea CKEditor bridge
 */
export default angular.module('cms.ckeditor.textarea.directive', [ckeditorConfig])
    .directive('ckeditorTextarea', function (CKEditorConfig, $rootScope) {

        const PREFIX = '__ckd_textarea_';
        var counter = 0;

        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                contentLoaded: '<'
            },
            link: function (scope, element, attrs, ngModel) {

                var editor;
                var options = angular.copy(CKEditorConfig.getOptions()) || {};
                var apply = function () {
                    if ($rootScope.$$phase != '$apply' && $rootScope.$$phase != '$digest') {
                        $rootScope.$apply();
                    }
                }

                angular.merge(options, {sharedSpaces: false});

                element[0].setAttribute('contenteditable', true);

                if (!attrs.id) {
                    attrs.$set('id', PREFIX + (++counter));
                }

                editor = CKEDITOR.replace(element[0], options);

                editor.on('instanceReady', function () {
                    editor.setData(ngModel.$viewValue || '');
                    apply();
                });

                editor.on('change', function (e) {
                    if (e.editor.checkDirty()) {
                        ngModel.$setViewValue(e.editor.getData());
                        e.editor.resetDirty();
                    }
                    apply();
                });

                scope.$watch('contentLoaded()', function (nV, oV) {
                    if(nV !== oV) {
                        editor.setData(ngModel.$viewValue || '');
                        apply();
                    }
                }, true);

                ngModel.$render = render;

                scope.$on('$destroy', function () {
                    editor.focusManager.blur(true);
                    editor.destroy();
                });


                scope.$on('language-changed', (event, language) => {
                    editor.destroy();
                    options.language = language.newLanguage;
                    editor = CKEDITOR.replace(element[0], options);
                });

                function render() {
                    element[0].innerHTML = ngModel.$viewValue || '';
                }
            }
        }
    }
).name;


// WEBPACK FOOTER //
// ./src/cmsCore/RichTextEditor/Editors/CKEditor/CKEditorTextarea.js